import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';
import { env } from '@configuration/env';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'content',
    component: () => import('../pages/VContentFrame.vue'),
  },
  {
    path: '/berichten',
    name: 'berichten',
    component: () => import('../pages/VBerichten.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

export const router = createRouter({
  history: createWebHistory(env.BASE_URL),
  routes,
  scrollBehavior(savedPosition): any {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});
